import { Box, HStack, Collapse, Heading, useDisclosure, VStack, Button, Text } from "@chakra-ui/react"
import { MdInfo } from "@react-icons/all-files/md/MdInfo";
import { MdEdit } from "@react-icons/all-files/md/MdEdit";
import { MdClose } from "@react-icons/all-files/md/MdClose";
import Markdown from "./components/markdown";
import JSONForm from "./JSONForm";
import { Panel } from "@xyflow/react";
import Modal from "./components/Modal";

interface NameDescData {
    name: string;
    desc?: string | null;
}

interface NameDescPanelProps {
    title: string;
    data: NameDescData;
    onUpdate?: ((formData: NameDescData) => Promise<void>) | null;
    defaultIsOpen?: boolean;
}

const NameDescPanel = ({ data, onUpdate, children, defaultIsOpen = true }: NameDescPanelProps) => {
    const { isOpen, onToggle } = useDisclosure({ defaultIsOpen: defaultIsOpen })
    const { isOpen: isEdit, onToggle: onToggleEdit, onClose: onCloseEdit } = useDisclosure({ defaultIsOpen: false })
    const { name, desc } = data;

    return <Panel position='bottom-left'>
        <HStack
            p={4}
            boxShadow="xl"
            rounded="10"
            align='center'
            bg="white">
            <Heading as='h3' size="sm" >
                {name}
            </Heading>
            <Button
                variant='ghost'
                aria-label="info"
                colorScheme="brand"
                borderWidth='2px'
                leftIcon={<MdInfo />}
                onClick={onToggle}
            >Info</Button>
        </HStack>
        <Modal isOpen={isOpen} header={`About ${name}`} size='3xl' onClose={onToggle}>
            <VStack w='full' align='stretch'>
                <HStack w='full' justify='space-between'>
                    <Text fontSize='sm' fontStyle='italic'>
                        Here is what you need to know about this flow
                    </Text>
                    <Box>
                        {onUpdate && <>
                            {isEdit ? (
                                <Button size='sm' variant='ghost' colorScheme="brand" leftIcon={<MdClose />} onClick={onToggleEdit}>Cancel</Button>) : (
                                <Button size='sm' variant='ghost' colorScheme="brand" leftIcon={<MdEdit />} onClick={onToggleEdit}>Edit</Button>)}
                        </>}
                    </Box>
                </HStack>
                <Box
                    as={Collapse}
                    in={isOpen}
                    dir="left"
                    animateOpacity
                    bg="white"
                    w='full'
                >
                    <VStack align='stretch'>
                        {(onUpdate && isEdit) ? <JSONForm<NameDescData>
                            uiSchema={{
                                "ui:options": { label: false },
                                desc: { "ui:widget": "textarea", "ui:help": "Markdown allowed", "ui:rows": 5, "ui:placeholder": "### What this flow does\n- it fetches your last instagram DM\n- sends an automatic answer" },
                            }}
                            schema={{
                                type: "object",
                                properties: {
                                    name: {
                                        type: "string",
                                        title: "Name",
                                        default: name,
                                    },
                                    desc: {
                                        type: "string",
                                        title: "Description",
                                        default: desc,
                                    },
                                },
                            }}
                            onSubmit={(formData) => onUpdate(formData).then(onCloseEdit)} /> : <Markdown children={desc} />}
                    </VStack>
                </Box>
            </VStack>
            {children}
        </Modal>
    </Panel>
}

export default NameDescPanel
